import { userSlimId } from '@webapp2/shared/model'
import { type MultiplayerSession } from '../../state'
import { adminState } from '../state'
import { ensureById } from './admin-entity-service'

export function ensureUserSlims(ids: string[]): Promise<void> {
  return ensureById('UserSlim', adminState.userSlims, ids, x => (adminState.userSlims = x))
}

export async function ensureUsersForMultiplayerSessions(sessions: MultiplayerSession[]): Promise<void> {
  const ids = sessions.map(x => userSlimId(x.userId)).concat(sessions.flatMap(x => x.invitedIds.map(userSlimId)))
  await ensureUserSlims(ids)
}

export function ensureUser(id: string) {
  return ensureById('User', adminState.users, [id], x => (adminState.users = x))
}
